import { SVGProps, Ref, forwardRef } from 'react';

export const PlayFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m15.114 6.53-4.378-2.22C7.69 2.762 6.166 1.99 5.083 2.87S4 5.759 4 9.778v4.444c0 4.02 0 6.029 1.083 6.908s2.607.107 5.653-1.44l4.378-2.22C19.704 15.14 22 13.974 22 12s-2.295-3.14-6.886-5.47"
                fill="currentColor"
            />
        </g>
    </svg>
));
PlayFilledSize24Glyph.displayName = 'PlayFilledSize24Glyph';
